<template>
  <div>
    <a-card :bordered="false" class="ant-pro-components-tag-select">
      <a-form layout="horizontal">
        <standard-form-row title="日统计">
          <a-form-item>
            <a-range-picker
              @change="handleChangeDate"
              format="YYYY-MM-DD"
              :ranges="{
                今天: [moment(), moment()],
                最近七天: [moment().subtract('days', 6), moment()],
                本月: [moment().startOf('month'), moment()]
              }"
              :placeholder="['开始日期', '结束日期']"
            />
          </a-form-item>
        </standard-form-row>
        <standard-form-row>
          <span class="table-page-search-submitButtons" style="float: right">
            <a-button type="primary" @click="getAnalysisOrder">查询</a-button>
          </span>
        </standard-form-row>
      </a-form>
    </a-card>
    <a-card :loading="loading" style="margin-top: 24px;" title="商品统计" :bordered="false">
      <div slot="extra" class="changeButton"><a-button @click="changeType">切换图表</a-button></div>
      <ve-chart
        :data="crtData"
        :height="'600px'"
        :data-empty="dataEmpty"
        :settings="chartSettings"
        :toolbox="toolbox"
        :legend="legend"
        :extend="extend"
        :title="crtTitle"
      >
      </ve-chart>
      <ve-chart
        :title="coursesTitle"
        :data="coursesData"
        :height="'600px'"
        :data-empty="dataEmpty"
        :settings="chartSettings"
        :toolbox="toolbox"
        :legend="legend"
        :extend="extend"
      >
      </ve-chart>
      <ve-chart
        :title="modesTitle"
        :data="modesData"
        :data-empty="dataEmpty"
        :settings="chartSettings"
        :toolbox="toolbox"
        :legend="legend"
        :extend="extend"
      >
      </ve-chart>
    </a-card>
  </div>
</template>

<script>
import { requestGet } from '@/api/api'
import { Slider } from 'ant-design-vue'
import { StandardFormRow, TagSelect } from '@/components'
import VeHistogram from 'v-charts/lib/histogram.common'
import VePie from 'v-charts/lib/pie.common'
import VeChart from 'v-charts/lib/chart.common'
import VeLine from 'v-charts/lib/line.common'

import 'echarts/lib/component/markLine'
import 'echarts/lib/component/title'
import 'echarts/lib/component/toolbox'
import 'v-charts/lib/style.css'

const TagSelectOption = TagSelect.Option

export default {
    name: 'OrderCharts',
    components: {
        TagSelect,
        TagSelectOption,
        StandardFormRow,
        [VeHistogram.name]: VeHistogram,
        [VeChart.name]: VeChart,
        [VePie.name]: VePie,
        ASlider: Slider,
        [VeLine.name]: VeLine
    },
    data () {
        this.extend = {
            series: {
                radius: '55%',
                center: ['60%', '60%'],
                label: {
                    show: true,
                    position: 'top',
                    color: '#4a4a4a'
                }
            }
        }
        this.toolbox = {
            feature: {
                saveAsImage: {}
            }
        }
        this.chartPieSettings = {}
        this.legend = {
            orient: 'vertical',
            left: 10,
            top: 10,
            bottom: 10
        }
        return {
            crtData: {
                columns: [],
                rows: []
            },
            crtTitle: {
                text: '证书商品统计',
                left: 'center'
            },
            coursesData: {
                columns: [],
                rows: []
            },
            coursesTitle: {
                text: '课程商品统计',
                left: 'center'
            },
            modesData: {
                columns: [],
                rows: []
            },
            modesTitle: {
                text: '考试模式商品统计',
                left: 'center'
            },
            params: {},
            type: 'histogram',
            chartSettings: {
                type: 'histogram'
            },
            loading: false,
            dataEmpty: true
        }
    },
    mounted () {
        this.getAnalysisOrder()
    },
    methods: {
        changeType: function () {
            const type = this.type === 'pie' ? 'histogram' : 'pie'
            this.type = type
            this.chartSettings.type = type
        },
        /**
         * 季度筛选
         * @val
         * @jdy
         * @2020-12-25
         */
        tagSelectChange (val, arr) {
            this.params.quarter = arr
        },
        /**
         * 月份正整数验证
         * @jdy
         * @2020-12-21
         */
        getNumberFormatter (value) {
            return value
        },
        /**
         * 月范围
         * @jdy
         * @2020-12-21
         */
        handleMonthOnChange (value, type) {
            console.log(value, type)
            if (type === 'first') {
                this.second.min = value
            } else if (type === 'second') {
                this.first.max = value
            }
        },
        /**
         * 修改维度类型，清空筛选值
         * @jdy
         * @2020-12-21
         */
        handleTypeOnChange (value) {
            delete this.params.quarter
            delete this.params.month
            delete this.params.day
        },
        /**
         * 获取图表数据
         * @jdy
         * @2020-12-16
         */
        getAnalysisOrder () {
            const { params } = this
            this.loading = !this.loading
            requestGet('/analysis/goods', params)
                .then(res => {
                    this.dataEmpty = false
                    this.crtData = res.result.certificates
                    this.coursesData = res.result.courses
                    this.modesData = res.result.modes
                })
                .catch(err => {
                    this.$notification.error(err)
                })
                .finally(() => {
                    this.loading = !this.loading
                })
        },
        /**
         * 筛选：日期筛选
         * params:{
         *  created_at_start
         *  created_at_end
         * }
         *
         * @params
         * @jdy
         * @2020-12-16
         */
        handleChangeDate (values) {
            if (values.length !== 0) {
                const start = this.moment(values[0]).format('YYYY-MM-DD') // 日期格式转换
                const end = this.moment(values[1]).format('YYYY-MM-DD') // 日期格式转换
                this.params.day = [start, end]
            } else {
                delete this.params.day // 清空日期删除键
            }
            this.getAnalysisOrder()
        }
    }
}
</script>

<style lang="less" scoped>
/deep/.ant-form-item {
    margin-bottom: 0;
}

/deep/.ant-btn-primary {
    color: #fff;
}

.ant-page-data-list {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    @media (max-width: 768px) {
        flex-direction: column;
    }
    li {
        flex: 1 1 auto;
        font-weight: bold;
        font-size: 1.5rem;
        position: relative;
        @media (min-width: 768px) {
            &:not(:last-child) {
                &::after {
                    content: '';
                    position: absolute;
                    height: 100%;
                    width: 1px;
                    background-color: rgba(0, 0, 0, 0.05);
                    right: 25px;
                    top: 0;
                }
            }
        }
        span {
            display: block;
            font-size: 0.875rem;
            color: #888;
            font-weight: normal;
        }
    }
}
.d-flex {
    div.pie-list {
        width: 50%;
    }
    span {
        padding: 0 0.75rem;
    }
}
.changeButton {
    text-align: center;
    margin: 0 auto !important;
}
</style>
